import * as React from 'react';

import Text from 'components/Text';

type Props = {
  count: number;
  unitText?: boolean;
};

function getUnitText(count: Number) {
  const unitsRemaining = count === 1 ? 'character left' : 'characters left';
  return count < 0 ? 'characters' : unitsRemaining;
}

const RemainingCharactersCount = ({ count, unitText }: Props) => {
  const textColor = count < 0 ? 'apple' : 'graphite';
  const displayString = `${count}${unitText ? ' ' + getUnitText(count) : ''}`;

  if (count <= 50) {
    return (
      <Text
        color={textColor}
        size="xxsmall"
        data-test="character-count"
        data-test-selector="character_count">
        {displayString}
      </Text>
    );
  }

  return null;
};

export default RemainingCharactersCount;
